<template>
  <v-row
    v-if="value && (value.title || value.paragraph)"
    :class="dense ? '' : 'mb-6'"
    justify="center"
  >
    <v-col class="text-center" cols="12" md="8">
      <TitleParagraphBlock
        em-class-title="text-light-blue-darken-2 font-weight-medium"
        :value="value"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import type { TitleParagraphBlockValue } from '#root/types/title-paragraph-block'

withDefaults(
  defineProps<{
    dense?: boolean
    value: TitleParagraphBlockValue
  }>(),
  {
    dense: false,
    value: undefined
  }
)
</script>
